<script setup lang="ts">
  import { Separator } from '@/components/ui/separator'
  import { cn } from '@/utils'
  import { computed } from 'vue'

  const props = defineProps({
    title: String,
    description: String,
    class: String
  })

  const headingTestId = computed(() => {
    if (!props.title) return undefined
    return 'page-heading-' + props.title.toLowerCase().replace(/\s+/g, '-')
  })
</script>

<template>
  <div :class="cn('flex justify-between gap-2 md:gap-4', $props.class)">
    <div class="flex flex-col justify-center gap-0.5">
      <h2 class="text-xl font-bold tracking-tight" :data-testid="headingTestId">{{ title }}</h2>
      <p class="text-xs text-muted-foreground sm:text-base">{{ description }}</p>
    </div>
    <div class="grid place-content-center">
      <slot />
    </div>
  </div>
  <Separator class="my-2" />
</template>
